<template>
  <div class="header">
    <progression v-if="indexProgressionCourante" :courant="indexProgressionCourante"/>
    <titre-applis :titre="titre" :sous-titre="sousTitre"/>
    <div v-if="indexProgressionSecondaire > 0">
      <p>Question {{ indexProgressionSecondaire }} / 12</p>
    </div>
    <repeater class="repeater" v-if="indexProgressionSecondaire" :courant="indexProgressionSecondaire" li-css-custom="barre_progression_secondaire" maximum="12"/>
  </div>
</template>

<script>
import Progression from './Progression';
import TitreApplis from './TitreApplis';
import Repeater from './Repeater';

export default {
  name: 'header-applis',
  components: {
    Repeater,
    TitreApplis,
    Progression
  },
  props: [
    'indexProgressionCourante',
    'titre',
    'sousTitre',
    'indexProgressionSecondaire'
  ]
}
</script>
